var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-header',{attrs:{"image":_vm.payload.image.url,"title":_vm.payload.title,"link":_vm.payload.link ? _vm.payload.link : null,"variant":_vm.payload.variant ? _vm.payload.variant : 'normal'}})}
var staticRenderFns = []

export { render, staticRenderFns }